import { notNull } from "@msys/common";
import { useUserData } from "../../auth/useUserData.js";
import { CustomFieldObjectType } from "../../../clients/graphqlTypes.js";
import { useTranslate } from "@tolgee/react";
import React from "react";

export function useCustomFieldObjectTypes() {
  const { t } = useTranslate("CustomFields");
  const viewer = useUserData().currentUser!;

  const customFieldObjectTypes = React.useMemo(
    () =>
      (
        [
          "Building",
          viewer.organisation.capabilities.includes("invoicing")
            ? "Invoice"
            : null,
          viewer.organisation.capabilities.includes("invoicing")
            ? "InvoiceItem"
            : null,
          viewer.organisation.capabilities.includes("ordering")
            ? "Order"
            : null,
          viewer.organisation.capabilities.includes("ordering")
            ? "OrderItem"
            : null,
          "Organisation",
          "Project",
          viewer.organisation.capabilities.includes("planning")
            ? "PlanSession"
            : null,
          viewer.organisation.capabilities.includes("quoting") ? "Quote" : null,
          viewer.organisation.capabilities.includes("quoting")
            ? "QuoteItem"
            : null,
          "User",
          "UserProjectMembership",
        ] as (CustomFieldObjectType | null)[]
      ).filter(notNull),
    [viewer.organisation.capabilities]
  );

  const customFieldObjectTypeLabels = React.useMemo(
    (): Record<CustomFieldObjectType, string> => ({
      Building: t("Building"),
      Order: t("Purchase order"),
      OrderItem: t("Purchase order item"),
      Organisation: t("Organisation"),
      Project: t("Project"),
      PlanSession: t("Planned session"),
      Quote: t("Quote"),
      QuoteItem: t("Quote item"),
      Invoice: t("Invoice"),
      InvoiceItem: t("Invoice item"),
      User: t("User"),
      UserProjectMembership: t("Project membership"),
    }),
    [t]
  );

  return { customFieldObjectTypes, customFieldObjectTypeLabels };
}
